import { call, put, select, takeEvery } from 'redux-saga/effects'

import { HIGHLIGHT_ROUTE } from '../actions'
import { route } from '../../../api'
import { updateRoute } from '../../../integrations/routes'

function* lazyLoadRouteDetails({ routeId }) {
    const currentData = yield select(state => state.routes[routeId])
    if (!currentData || currentData.points) return

    try {
        const res = yield call(route.read, routeId)
        yield put(updateRoute(res))
    } catch (error) {
        yield call(console.error, error)
    }
}

/**
 * Handles routes being highlighted.
 */
export default function* highlightRouteSaga() {
    yield takeEvery(HIGHLIGHT_ROUTE, lazyLoadRouteDetails)
}
